import React from 'react';
import { Facebook, Instagram, Youtube, ExternalLink } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-[#050505] py-12 border-t border-rhino-grey/50" data-id="element-70">
      <div className="container mx-auto px-6 flex flex-col items-center" data-id="element-71">
        <a href="#home" className="mb-4" data-id="element-72">
          <img src="https://cdn.magicpatterns.com/uploads/k32AHgZ5QWqakPbqyEoYha/4bfafa20-dc71-4720-a5fb-1cff6c6dca54.png" alt="Rhino Strong Logo" className="h-20 w-auto brightness-200 invert" data-id="element-73" />
        </a>

        <p className="text-gray-500 text-sm uppercase tracking-widest mb-8 text-center" data-id="element-74">
          Equipped with Strength, Empowered by Faith
        </p>

        <div className="flex gap-6 mb-8" data-id="element-75">
          <a href="https://tiktok.com/@rhinoman046" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-white transition-colors" aria-label="TikTok" data-id="element-76">
            <ExternalLink size={20} data-id="element-77" />
          </a>
          <a href="https://facebook.com/Rhinoman60" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#1877F2] transition-colors" aria-label="Facebook" data-id="element-78">
            <Facebook size={20} data-id="element-79" />
          </a>
          <a href="https://instagram.com/Rhinoman1960" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#E1306C] transition-colors" aria-label="Instagram" data-id="element-80">
            <Instagram size={20} data-id="element-81" />
          </a>
          <a href="https://youtube.com/@rhinostrong2025" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#FF0000] transition-colors" aria-label="YouTube" data-id="element-82">
            <Youtube size={20} data-id="element-83" />
          </a>
        </div>

        <div className="w-full max-w-md h-px bg-rhino-grey/50 mb-8" data-id="element-84"></div>

        <p className="text-gray-600 text-xs" data-id="element-85">
          &copy; 2026 Rhino Strong. All rights reserved.
        </p>
      </div>
    </footer>;
}